import { render, staticRenderFns } from "./CrewDashboard.vue?vue&type=template&id=2d6f7e70&scoped=true&"
import script from "./CrewDashboard.vue?vue&type=script&lang=ts&"
export * from "./CrewDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CrewDashboard.vue?vue&type=style&index=0&id=2d6f7e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f7e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
